module.exports = __webpack_public_path__ + "static/app-announce-2e8b81a4a76b6130582c2456d96a71ae.png";